import { Card, Form, Message } from "semantic-ui-react"
import useError from "../../hooks/useError"

const BasePage = ({ children }: { children: any }) => {
    const { error } = useError()
    return (
        <Card fluid className="card-form">
            <Card.Content>
                <Form
                    error={Boolean(error && error['detail'])}
                    //success={Boolean(userStore.checkSucess())}
                >
                    <Message
                        icon="times circle outline"
                        error
                        header={(error || {})['detail']}
                    />
                    {/* <Message icon="check circle outline" success
                        header={successMessage}
                    /> */}
                    {children}
                </Form>
            </Card.Content>
    </Card>)
}

export default BasePage